import { render, staticRenderFns } from "./AdminFinalApproval.vue?vue&type=template&id=1c20c916&scoped=true"
import script from "./AdminFinalApproval.vue?vue&type=script&lang=js"
export * from "./AdminFinalApproval.vue?vue&type=script&lang=js"
import style0 from "./AdminFinalApproval.vue?vue&type=style&index=0&id=1c20c916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20c916",
  null
  
)

export default component.exports